package org.zest.insan_360_website.data

import org.zest.insan_360_website.model.Attribute
import org.zest.insan_360_website.pages.Question
import org.zest.insan_360_website.pages.Statement

fun statement(
    en: String,
    bm: String,
    moreAttr: Attribute,
    lessAttr: Attribute
): Statement {
    return Statement(en, bm, moreAttr, lessAttr)
}

val QUESTIONS: List<Question> = listOf(
        Question(
            listOf(
                statement("Easy-going, Agreeable", "Mudah mesra, Mudah bergaul", Attribute.Steadiness, Attribute.Steadiness),
                statement("Trusting, Believing in others", "Mudah percaya pada orang lain", Attribute.Influence, Attribute.Influence),
                statement("Adventurous, Risk taker", "Suka mencuba, Berani mengambil risiko", Attribute.Dummy, Attribute.Dominance),
                statement("Tolerant, Respectful", "Bertolak ansur, Menghormati orang lain", Attribute.Compliance, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Soft spoken, Reserved", "Bercakap lembut, Pendiam", Attribute.Compliance, Attribute.Dummy),
                statement("Optimistic, Visionary", "Optimistik, Berwawasan", Attribute.Dominance, Attribute.Dominance),
                statement("Center of attention, Sociable", "Menjadi tumpuan perhatian, Suka bersosial", Attribute.Dummy, Attribute.Influence),
                statement("Peacemaker, Bring harmony", "Pendamai, Membawa keharmonian", Attribute.Steadiness, Attribute.Steadiness)
            )
        ),
        Question(
            listOf(
                statement("Encourage others", "Memberi galakan buat orang lain", Attribute.Influence, Attribute.Influence),
                statement("Strive for perfection", "Berusaha mencapai kesempurnaan", Attribute.Dummy, Attribute.Compliance),
                statement("Be part of the team", "Menjadi sebahagian daripada pasukan", Attribute.Dummy, Attribute.Steadiness),
                statement("Want to establish goals", "Mahukan matlamat yang jelas", Attribute.Dominance, Attribute.Dummy)
            )
        ),
        Question(
            listOf(
                statement("Become frustrated", "Mudah berasa kecewa", Attribute.Compliance, Attribute.Compliance),
                statement("Keep my feelings inside", "Memendam rasa sendiri", Attribute.Steadiness, Attribute.Steadiness),
                statement("Tell my side of the story", "Menyatakan pandangan saya", Attribute.Dummy, Attribute.Influence),
                statement("Stand up to opposition", "Berani membangkang", Attribute.Dominance, Attribute.Dominance)
            )
        ),
        Question(
            listOf(
                statement("Lively, Talkative", "Ceria, Banyak bercakap", Attribute.Influence, Attribute.Dummy),
                statement("Fast paced, Determined", "Pantas, Bertekad", Attribute.Dominance, Attribute.Dominance),
                statement("Try to maintain balance", "Berusaha mengekalkan keseimbangan", Attribute.Steadiness, Attribute.Steadiness),
                statement("Try to follow the rules", "Cuba mematuhi peraturan", Attribute.Dummy, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Manage time efficiently", "Mengurus masa dengan cekap", Attribute.Compliance, Attribute.Dummy),
                statement("Often rushed, Feel pressured", "Sering tergesa-gesa, Berasa tertekan", Attribute.Dominance, Attribute.Dominance),
                statement("Social things are important", "Pentingkan perkara berkaitan sosial", Attribute.Influence, Attribute.Influence),
                statement("Like to finish what I start", "Suka menyelesaikan apa yang dimulakan", Attribute.Steadiness, Attribute.Steadiness)
            )
        ),
        Question(
            listOf(
                statement("Resist sudden change", "Tidak suka perubahan mengejut", Attribute.Steadiness, Attribute.Dummy),
                statement("Tend to over promise", "Cenderung berjanji secara berlebihan", Attribute.Influence, Attribute.Influence),
                statement("Withdraw under pressure", "Menarik diri apabila tertekan", Attribute.Dummy, Attribute.Compliance),
                statement("Not afraid to fight", "Tidak takut untuk berjuang", Attribute.Dummy, Attribute.Dominance)
            )
        ),
        Question(
            listOf(
                statement("A good encourager", "Seorang yang pandai memberi galakan", Attribute.Influence, Attribute.Influence),
                statement("A good listener", "Seorang pendengar yang baik", Attribute.Steadiness, Attribute.Steadiness),
                statement("A good analyzer", "Seorang penganalisis yang baik", Attribute.Compliance, Attribute.Compliance),
                statement("A good delegator", "Seorang yang pandai delegasi", Attribute.Dominance, Attribute.Dominance)
            )
        ),
        Question(
            listOf(
                statement("Results are what matter", "Keputusan dan hasil adalah yang utama", Attribute.Dominance, Attribute.Dominance),
                statement("Do it right, Accuracy counts", "Buat dengan betul, Ketepatan itu penting", Attribute.Compliance, Attribute.Compliance),
                statement("Make it enjoyable", "Jadikan ia menyeronokkan", Attribute.Dummy, Attribute.Influence),
                statement("Let's do it together", "Mari lakukan bersama", Attribute.Dummy, Attribute.Steadiness)
            )
        ),
        Question(
            listOf(
                statement("Will do without, Self-controlled", "Boleh menahan diri, Berdisiplin", Attribute.Dummy, Attribute.Compliance),
                statement("Will buy on impulse", "Membeli secara mengejut tanpa berfikir", Attribute.Dominance, Attribute.Dominance),
                statement("Will wait, No pressure", "Sanggup menunggu, Tiada tekanan", Attribute.Steadiness, Attribute.Steadiness),
                statement("Will spend on what I want", "Berbelanja untuk apa yang saya mahu", Attribute.Influence, Attribute.Dummy)
            )
        ),
        Question(
            listOf(
                statement("Friendly, Easy to be with", "Mesra, Mudah didekati", Attribute.Steadiness, Attribute.Dummy),
                statement("Unique, Bored by routine", "Unik, Cepat bosan dengan rutin", Attribute.Dummy, Attribute.Influence),
                statement("Actively change things", "Aktif melakukan perubahan", Attribute.Dominance, Attribute.Dominance),
                statement("Want things exact", "Mahukan ketepatan", Attribute.Compliance, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Non-confrontational, Giving in", "Mengelakkan konflik, Mudah mengalah", Attribute.Dummy, Attribute.Steadiness),
                statement("Overloaded with details", "Terlalu banyak perincian", Attribute.Compliance, Attribute.Dummy),
                statement("Changes at the last minute", "Perubahan pada saat akhir", Attribute.Influence, Attribute.Influence),
                statement("Demanding, Abrupt", "Menuntut, Kasar", Attribute.Dominance, Attribute.Dominance)
            )
        ),
        Question(
            listOf(
                statement("Want advancement", "Mahukan kemajuan dalam hidup", Attribute.Dominance, Attribute.Dominance),
                statement("Satisfied with things, Content", "Berpuas hati dengan keadaan semasa", Attribute.Steadiness, Attribute.Dummy),
                statement("Openly display feelings", "Menunjukkan perasaan secara terbuka", Attribute.Influence, Attribute.Dummy),
                statement("Humble, Modest", "Rendah hati, Bersederhana", Attribute.Dummy, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Cool, Reserved", "Tenang, Pendiam", Attribute.Compliance, Attribute.Compliance),
                statement("Happy, Carefree", "Gembira, Bebas tanpa kerunsingan", Attribute.Influence, Attribute.Influence),
                statement("Pleasing, Kind", "Baik hati, Suka membantu", Attribute.Steadiness, Attribute.Dummy),
                statement("Bold, Daring", "Berani, Ambil risiko", Attribute.Dominance, Attribute.Dominance)
            )
        ),
        Question(
            listOf(
                statement("Spend quality time with others", "Menghabiskan masa berkualiti bersama orang lain", Attribute.Steadiness, Attribute.Steadiness),
                statement("Plan for the future, Be prepared", "Merancang masa depan, Bersedia", Attribute.Compliance, Attribute.Dummy),
                statement("Travel to new adventures", "Menjelajah untuk mencari cabaran baharu", Attribute.Influence, Attribute.Influence),
                statement("Receive rewards for goals met", "Menerima ganjaran atas pencapaian matlamat", Attribute.Dominance, Attribute.Dominance)
            )
        ),
        Question(
            listOf(
                statement("Rules need to be challenged", "Peraturan perlu dicabar", Attribute.Dummy, Attribute.Dominance),
                statement("Rules make it fair", "Peraturan menjadikan keadaan adil", Attribute.Compliance, Attribute.Dummy),
                statement("Rules make it boring", "Peraturan menjadikan sesuatu perkara itu membosankan", Attribute.Influence, Attribute.Influence),
                statement("Rules make it safe", "Peraturan memberikan keselamatan", Attribute.Steadiness, Attribute.Steadiness)
            )
        ),
        Question(
            listOf(
                statement("Education, Culture", "Pendidikan, Budaya", Attribute.Dummy, Attribute.Compliance),
                statement("Achievements, Awards", "Pencapaian, Anugerah", Attribute.Dominance, Attribute.Dominance),
                statement("Safety, Security", "Keselamatan, Perlindungan", Attribute.Steadiness, Attribute.Steadiness),
                statement("Social, Group Gatherings", "Aktiviti sosial, Perhimpunan kumpulan", Attribute.Influence, Attribute.Dummy)
            )
        ),
        Question(
            listOf(
                statement("Take charge, Direct approach", "Mengambil alih kepimpinan, Pendekatan Secara berterus terang", Attribute.Dominance, Attribute.Dominance),
                statement("Outgoing, Enthusiastic", "Peramah, Bersemangat", Attribute.Dummy, Attribute.Influence),
                statement("Predictable, Consistent", "Boleh diramal, Istiqamah", Attribute.Dummy, Attribute.Steadiness),
                statement("Cautious, Careful", "Berhati-hati, Cermat", Attribute.Compliance, Attribute.Dummy)
            )
        ),
        Question(
            listOf(
                statement("Not easily defeated", "Tidak mudah berputus asa", Attribute.Dominance, Attribute.Dominance),
                statement("Will do as told, Follows leader", "Akan menurut arahan, Mengikut ketentuan pemimpin", Attribute.Steadiness, Attribute.Dummy),
                statement("Excitable, Cheerful", "Bersemangat, Ceria", Attribute.Influence, Attribute.Influence),
                statement("Want things orderly, Neat", "Mahukan keadaan teratur, Kemas", Attribute.Dummy, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("I will lead them", "Saya akan memimpin mereka", Attribute.Dominance, Attribute.Dummy),
                statement("I will follow through", "Saya akan memastikan ia dilaksanakan", Attribute.Steadiness, Attribute.Steadiness),
                statement("I will persuade them", "Saya akan memujuk mereka", Attribute.Influence, Attribute.Influence),
                statement("I will get the facts", "Saya akan mendapatkan fakta", Attribute.Compliance, Attribute.Dummy)
            )
        ),
        Question(
            listOf(
                statement("Think of others first", "Memikirkan orang lain terlebih dahulu", Attribute.Steadiness, Attribute.Steadiness),
                statement("Competitive, Like a challenge", "Suka bersaing, Suka cabaran", Attribute.Dominance, Attribute.Dominance),
                statement("Optimistic, Positive", "Optimistik, Positif", Attribute.Influence, Attribute.Influence),
                statement("Logical thinker, Systematic", "Berfikir secara logik dan sistematik", Attribute.Dummy, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Please others, Agreeable", "Menyenangkan orang lain, Mudah bersetuju", Attribute.Steadiness, Attribute.Steadiness),
                statement("Laugh out loud, Animated", "Ketawa dengan kuat, Ceria", Attribute.Dummy, Attribute.Influence),
                statement("Courageous, Bold", "Berani, Berani mencuba", Attribute.Dominance, Attribute.Dominance),
                statement("Quiet, Reserved", "Pendiam, Tidak menonjol", Attribute.Compliance, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Want more authority", "Mahukan lebih kuasa atau autoriti", Attribute.Dummy, Attribute.Dominance),
                statement("Want new opportunities", "Mahukan peluang baharu", Attribute.Influence, Attribute.Dummy),
                statement("Avoid any conflict", "Mengelakkan konflik", Attribute.Steadiness, Attribute.Steadiness),
                statement("Want clear directions", "Mahukan arahan yang jelas", Attribute.Dummy, Attribute.Compliance)
            )
        ),
        Question(
            listOf(
                statement("Reliable, Dependable", "Boleh dipercayai, Boleh diharapkan", Attribute.Dummy, Attribute.Steadiness),
                statement("Creative, Unique", "Kreatif, Unik", Attribute.Influence, Attribute.Influence),
                statement("Bottom line, Results oriented", "Fokus pada hasil dan keputusan", Attribute.Dominance, Attribute.Dummy),
                statement("Hold high standards, Accurate", "Memegang standard tinggi, Teliti", Attribute.Compliance, Attribute.Dummy)
            )
        )
    )